"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _pipelinesApi = _interopRequireDefault(require("../api/pipelinesApi"));

var _pipelineActions = require("../actions/pipelineActions");

var getPipelinesEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _pipelinesApi.default.getPipelines,
  initiatingActionType: _pipelineActions.PipelineActionTypes.GET_PIPELINES,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _pipelineActions.receiveGetPipelines
}));

var _default = (0, _reduxObservable.combineEpics)(getPipelinesEpic);

exports.default = _default;
module.exports = exports.default;